import { gql } from '@apollo/client';

export const COUNT_LINK_CLICK = gql`
  mutation CountLinkClick($linkId: Int, $url: AWSURL) {
    countLinkClick(linkId: $linkId, url: $url)
  }
`;
